import React from "react";
import type { MenuProps } from "@mui/material";

export const useMenuState = () => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const closeMenu = () => setAnchorEl(null);

	const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		event.stopPropagation();

		if (open) {
			closeMenu();

			return;
		}

		setAnchorEl(event.currentTarget);
	};

	const handleClose = (event: Event, reason?: string) => {
		if (reason === "backdropClick") {
			event?.preventDefault();
			event?.stopPropagation();
		}

		closeMenu();
	};

	const handleMenuItemClick: MenuProps["onClick"] = () => {
		closeMenu();
	};

	return { anchorEl, open, handleOpen, handleClose, handleMenuItemClick };
};
